import { ApplicationRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Action, DockingBarService } from '@amfam/ui-kit';

@Directive()
export abstract class TermsComponentDirective implements OnInit, OnDestroy {
  private queryParamsSubscription: Subscription;
  constructor(
    protected dockingService: DockingBarService,
    private route: ActivatedRoute,
    private application: ApplicationRef
  ) {}

  ngOnInit() {
    const action = new Action('Print', () => {
      window.print();
    });
    this.dockingService.registerAction(action);
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  protected onContentLoad() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(queryParams => {
      if (typeof queryParams['print'] !== 'undefined') {
        this.application.tick();
        window.print();
      }
    });
  }
}
